import { CEFR_LEVELS } from '@repo/config';
import { z } from 'zod';
import { grammarPatternSchema } from './grammar-pattern-schema';
import { grammarTeachingSchema } from './grammar-teaching-schema';

const kebabCaseSchema = z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

const grammarPointExampleSchema = z.object({
  id: z.number().int().optional(),
  text: z.string(),
  highlight: z.string().optional(),
});

const grammarL1TrapSchema = z.object({
  locales: z.array(z.string().min(2).max(5)).min(1).max(8),
  learnerProduces: z.string().min(3).max(90),
  sourceStructure: z.string().min(10).max(160),
});

const grammarPointSchemaDefinition = z.object({
  slug: kebabCaseSchema,
  level: z.enum(CEFR_LEVELS),
  subBand: z.string(),
  family: z.string(),
  sortOrder: z.number().int(),
  title: z.string(),
  formula: z.string(),
  pattern: grammarPatternSchema.nullable().optional(),
  jobLine: z.string(),
  whenToUse: z.string(),
  contrastNotes: z.string().nullable().optional(),
  machinePattern: z.string().nullable().optional(),
  teaching: grammarTeachingSchema.nullish(),
  confusableWith: z.array(kebabCaseSchema).max(4).nullish(),
  examples: z.array(grammarPointExampleSchema).min(4),
  errorNotes: z.record(z.string(), z.string()),
  prerequisites: z.array(kebabCaseSchema),
  mustCover: z.array(kebabCaseSchema).min(2).max(6).optional(),
  l1Traps: z.array(grammarL1TrapSchema).max(12).optional(),
  premium: z.boolean().default(false),
});

export const grammarPointSchema: typeof grammarPointSchemaDefinition = grammarPointSchemaDefinition;

export type IGrammarPoint = z.infer<typeof grammarPointSchema>;
